import { render } from "./FileViewer.vue?vue&type=template&id=5c4e6f9d"
import script from "./FileViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./FileViewer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/exhishare/FileViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c4e6f9d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c4e6f9d', __exports__)) {
    api.reload('5c4e6f9d', __exports__)
  }
  
  module.hot.accept("./FileViewer.vue?vue&type=template&id=5c4e6f9d", () => {
    api.rerender('5c4e6f9d', render)
  })

}


export default __exports__